import './PrivatePolicy.css';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../../states/NavigationBar';

function PrivatePolicy() {
    const setNavigationBarState = useSetRecoilState(navigationBarState);

    useEffect(() => {
        setNavigationBarState({
            title: '개인정보처리방침',
            'left-item': { type: 'back' },
        });
    }, [setNavigationBarState]);

    return (
        <div className="privacy-page">
            <div className="privacy-container">
                <div className="privacy-header">
                    <h1 className="privacy-title">개인정보처리방침</h1>
                    <p className="privacy-subtitle">주식회사 케이비티영어교육 개인정보 보호정책</p>
                </div>

                <div className="privacy-content">
                    <div className="privacy-intro">
                        주식회사 케이비티영어교육(이하 "회사")는 정보통신망이용촉진및정보보호등에관한법률(이하 "정보통신망법") 등
                        정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한
                        개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
                    </div>

                    {/* Section 1 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">1</span>
                            개인정보 수집 목적 및 이용
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                회사는 회원님께서 회사의 서비스를 이용하는데 있어, 원활한 서비스 사용 및 회원님에게
                                편리하고 유익한 정보를 제공하기 위한 최소한의 정보를 수집합니다.
                            </p>
                            <p>
                                회원님께서 제공하신 모든 정보는 상기 목적에 필요한 용도 이외로는 사용되지 않으며,
                                수집 정보의 범위나 사용 목적, 용도가 변경될 시에는 반드시 회원님께 사전 동의를 구할 것입니다.
                            </p>
                        </div>
                    </div>

                    {/* Section 2 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">2</span>
                            개인정보 수집 항목 및 보유, 이용 기간
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                회사는 회원 서비스를 위해 필수적으로 제공받는 회원 정보는 이름, ID, 비밀번호, 휴대폰 번호,
                                모바일 Push ID입니다. 또한 서비스 이용과정에서 입력하는 데이터(텍스트 입력내용, 음성 녹음 등) 정보가 수집됩니다.
                                자격증 수령 신청 시 배송을 위한 주소 정보가 추가로 수집됩니다.
                            </p>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">이름 및 휴대폰 번호의 수집 및 이용 목적</div>
                            <ul className="privacy-list">
                                <li>회원가입 시 본인 확인 및 인증</li>
                                <li>시험 일정, 결과, 공지사항 등 중요 안내를 위한 카카오톡 알림톡 또는 SMS 발송</li>
                                <li>서비스 관련 긴급 공지 및 안내</li>
                                <li>고객 문의 응대 및 본인 확인</li>
                            </ul>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">주소의 수집 및 이용 목적</div>
                            <ul className="privacy-list">
                                <li>자격증 수령 신청 시 실물 자격증 배송</li>
                            </ul>
                        </div>
                        <div className="privacy-section-text" style={{ marginTop: '16px' }}>
                            <p>
                                회원님께서 회사에서 제공하는 서비스를 받는 동안 회원님의 개인 정보는 회사에서 계속 보유하며
                                서비스 제공을 위해 이용하게 됩니다.
                            </p>
                            <p>
                                단, 회사에 탈퇴를 요청하거나 표명된 회원 자격 상실 사유에 의해 회원 자격을 제한 및 정지시키는 경우에는
                                해당 개인의 정보는 재생할 수 없는 기술적 방법에 의해 삭제되며, 어떠한 용도로도 열람 또는 이용될 수 없도록 처리됩니다.
                            </p>
                        </div>
                    </div>

                    {/* Section 3 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">3</span>
                            개인정보 제공 및 공유
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                원칙적으로 회사는 회원님의 내부정보를 서비스와 무관한 타 기업, 기관에 절대 공개하지 않습니다.
                            </p>
                            <p>
                                다만, 회원님이 공개에 동의한 경우 또는 회사의 이용약관을 위배하거나 회사의 서비스를 이용하여
                                타인에게 피해를 주거나 미풍양속을 해치는 위법행위를 한 사람 등에게 법적인 조치를 취하기 위해
                                개인 정보를 공개해야 한다고 판단되는 경우에는 예외로 합니다.
                            </p>
                        </div>
                    </div>

                    {/* Section 4 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">4</span>
                            개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                회원님 개개인에게 개인화되고 맞춤화된 서비스를 제공하기 위해서 당사는 회원님을 식별할 수 있는
                                '쿠키(cookie)'를 사용합니다. 쿠키는 웹 사이트를 운영하는데 이용되는 서버가 사용자의 브라우저에게
                                보내는 조그마한 데이터 꾸러미로 회원님 컴퓨터의 하드디스크에 저장됩니다.
                            </p>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">쿠키의 사용 목적</div>
                            <ul className="privacy-list">
                                <li>회원의 정보를 식별하고 일정 기간내 서비스 재방문시 지속적인 서비스 제공</li>
                            </ul>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">쿠키 설정 거부 방법</div>
                            <div className="privacy-section-text">
                                <p>
                                    귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써
                                    모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
                                </p>
                                <p>
                                    단, 쿠키 설치를 거부하였을 경우 로그인이 필요한 일부 서비스의 이용이 어려울 수 있습니다.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-subsection">
                            <div className="privacy-subsection-title">모바일 앱(APP) 알림서비스</div>
                            <div className="privacy-section-text">
                                <p>
                                    모바일 앱(APP) 알림서비스 허용시 맞춤서비스를 제공하기 위해서 당사는 회원님의 모바일 Push ID를 저장하고 사용합니다.
                                </p>
                            </div>
                            <ul className="privacy-list">
                                <li>회사에서 발행되는 정보와 소식 및 공지 알림서비스 제공</li>
                                <li>맞춤 교육 알림서비스 제공</li>
                            </ul>
                        </div>
                    </div>

                    {/* Section 5 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">5</span>
                            기술적, 관리적 대책
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                회원님의 정보는 비밀번호에 의해 보호되고 있습니다. 또한 회사의 모든 사용자 정보 획득 요청은
                                쿠키에 저장되는 JSON Web Token 사용자 자격증명 방식을 사용하여 자원의 권한을 관리하고 있습니다.
                            </p>
                            <p>
                                또한 회사에서는 서버 및 네트워크 관련 보안시스템을 갖추고 있습니다. 회사는 개인 정보 취급 직원을
                                최소화는 물론 각 직원별 회원정보 접근 권한을 달리하고, 수시보안교육을 통해 본 정책의 준수를 강조하고 있습니다.
                            </p>
                            <p>
                                회사에서는 외부로부터 철저하게 격리시켜 철저한 보안을 유지시키고 있습니다.
                                회원정보 접근 권한을 구분하는 시스템과 보안교육을 통해 내부 침입에도 대응하고 있습니다.
                            </p>
                        </div>
                    </div>

                    {/* Section 6 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">6</span>
                            개인정보 열람과 정정 및 철회
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                회원님은 언제든지 제공된 개인 정보를 열람, 정정, 삭제를 요청하실 수 있습니다.
                                개인 정보 열람 및 정정, 삭제는 회사 사이트의 서비스 관리자(ex. 학원 관리자)에게 요청하여 정정이 가능합니다.
                            </p>
                            <p>
                                만일 회원 탈퇴를 통하여 개인 정보 제공에 대한 동의를 철회하고 개인정보를 삭제하려면,
                                서비스 관리자에게 요청하여 처리할 수 있습니다.
                            </p>
                            <p>
                                이 때 회사는 회원 탈퇴의 진위를 확인한 후 지체 없이 필요한 조치를 취하여, 이용자의 개인 정보를 파기하고
                                어떠한 용도로도 이용되지 않도록 처리합니다.
                            </p>
                            <p>
                                개인 정보와 관련하여 불만이나 의견이 있으신 분은 회사 고객센터나 회사 개인정보 관리 책임자 메일로
                                의견을 주시면 접수 즉시 조치하고 처리 결과를 통보해 드리겠습니다.
                            </p>
                        </div>
                    </div>

                    {/* Section 7 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">7</span>
                            개인 아이디와 비밀번호 관리
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                회원님이 사용하고 계시는 ID와 비밀번호는 원칙적으로 회원님만이 사용하도록 되어 있습니다.
                            </p>
                            <p>
                                회사의 고의 또는 과실이 없는 경우에, 회원님의 ID와 비밀번호 도용 또는 기타 타인의 사용으로 의해
                                발생된 문제에 대하여 회사가 책임지지 않습니다.
                            </p>
                            <p>
                                어떠한 경우에도 비밀번호는 타인에게 알려 주지 마시고 로그온 상태에서는 주위의 다른 사람에게
                                개인 정보가 유출되지 않도록 특별한 주의를 기울여 주시기 바랍니다.
                            </p>
                        </div>
                    </div>

                    {/* Section 8 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">8</span>
                            개인정보관리책임자 및 상담신고
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 당사는 개인정보관리책임자를 두고 있습니다.
                                고객의 개인정보와 관련한 문의사항이 있으시면 아래의 개인정보관리책임자 또는 개인정보관리담당자에게 연락 주시기 바랍니다.
                            </p>
                        </div>
                        <div className="privacy-contact-box">
                            <div style={{ marginBottom: '16px' }}>
                                <strong style={{ color: '#101828', fontSize: '14px' }}>개인정보 관리책임자</strong>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label">성명</span>
                                <span className="privacy-contact-value">김영국 대표이사</span>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label">연락처</span>
                                <span className="privacy-contact-value">02-929-5114</span>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label">이메일</span>
                                <span className="privacy-contact-value">googky1@naver.com</span>
                            </div>
                        </div>
                        <div className="privacy-contact-box">
                            <div style={{ marginBottom: '16px' }}>
                                <strong style={{ color: '#101828', fontSize: '14px' }}>개인정보 관리담당자</strong>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label">성명</span>
                                <span className="privacy-contact-value">김영국 이사</span>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label">연락처</span>
                                <span className="privacy-contact-value">02-929-5114</span>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label">이메일</span>
                                <span className="privacy-contact-value">googky1@naver.com</span>
                            </div>
                        </div>
                        <div className="privacy-section-text" style={{ marginTop: '16px' }}>
                            <p>
                                개인정보침해에 관한 상담이 필요한 경우에는 아래 기관으로 문의하실 수 있습니다.
                            </p>
                        </div>
                        <div className="privacy-contact-box">
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label" style={{ minWidth: '180px' }}>개인정보침해신고센터</span>
                                <span className="privacy-contact-value">국번없이 118</span>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label" style={{ minWidth: '180px' }}>대검찰청 인터넷범죄수사센터</span>
                                <span className="privacy-contact-value">국번없이 1301</span>
                            </div>
                            <div className="privacy-contact-item">
                                <span className="privacy-contact-label" style={{ minWidth: '180px' }}>경찰청 사이버안전국</span>
                                <span className="privacy-contact-value">국번없이 182</span>
                            </div>
                        </div>
                    </div>

                    {/* Section 9 */}
                    <div className="privacy-section">
                        <div className="privacy-section-title">
                            <span className="privacy-section-number">9</span>
                            개인정보처리방침의 변경
                        </div>
                        <div className="privacy-section-text">
                            <p>
                                이 개인정보처리방침은 법령, 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는
                                변경사항 시행일의 7일 전부터 회사 웹사이트 또는 앱을 통해 공지할 것입니다.
                            </p>
                        </div>
                    </div>

                    <div className="privacy-footer">
                        <div className="privacy-effective-date">
                            <strong>개인정보처리방침 시행일자: 2025년 11월 30일</strong>
                            <br />
                            이 약관은 2025년 11월 30일부터 시행합니다.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivatePolicy;
